import { render, staticRenderFns } from "./DocumentNav.vue?vue&type=template&id=549a2827&scoped=true&"
import script from "./DocumentNav.vue?vue&type=script&lang=js&"
export * from "./DocumentNav.vue?vue&type=script&lang=js&"
import style0 from "./DocumentNav.vue?vue&type=style&index=0&id=549a2827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549a2827",
  null
  
)

export default component.exports